import { useEffect, useRef } from 'react';
import { io } from 'socket.io-client';

let socketInstance = null;

export const useSocket = (token) => {
    const socketRef = useRef(null);

    useEffect(() => {
        if (token && !socketInstance) {
            try {
                const socketUrl = window.location.origin;
                console.log('🔄 Init WebSocket Connection:', socketUrl);

                socketInstance = io(socketUrl, {
                    path: '/api/socket.io',
                    auth: { token },
                    transports: ['websocket', 'polling'], // 🟢 FIX: Echte websockets toestaan (veel stabieler)
                    reconnection: true, // 🟢 FIX: Nooit opgeven, altijd blijven proberen te verbinden!
                    reconnectionAttempts: 10,
                    reconnectionDelay: 2000,
                    timeout: 10000
                });

                socketInstance.on('disconnect', (reason) => { 
                    // Bij een server herstart, direct weer verbinden
                    if(reason === 'io server disconnect' && socketInstance) socketInstance.connect(); 
                });
                
                socketInstance.on('connect', () => {
                    console.log('🟢 ⚡ Realtime WebSocket verbonden!', socketInstance.id);
                });

                socketInstance.on('connect_error', (err) => {
                    console.warn('⚠️ WebSocket hapert even, we proberen het opnieuw...', err.message);
                    // 🟢 FIX: We hebben de socketInstance.disconnect() verwijderd! 
                    // Hij trekt niet meer zelf de stekker eruit.
                });

            } catch (error) {
                console.warn('Socket initialisatie overgeslagen.');
            }
        }

        socketRef.current = socketInstance;

        if (!token && socketInstance) {
            socketInstance.disconnect();
            socketInstance = null;
        }
    }, [token]);

    const startLiveWorkout = (type) => {
        if (socketInstance && socketInstance.connected) {
            socketInstance.emit('workout:start', { type });
        } else {
            // Als de socket écht niet wil, proberen we het stille fallback HTTP endpoint
            fetch('/api/workouts/live/start', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` },
                body: JSON.stringify({ type })
            }).catch(() => {});
        }
    };

    const stopLiveWorkout = () => {
        if (socketInstance && socketInstance.connected) {
            socketInstance.emit('workout:stop');
        } else {
            fetch('/api/workouts/live/stop', {
                method: 'POST',
                headers: { 'Authorization': `Bearer ${token}` }
            }).catch(() => {});
        }
    };

    return { socket: socketInstance, startLiveWorkout, stopLiveWorkout };
};
